import { P00039DataRxTxIndex } from '../../P00039Sync';

import { Pool } from '../../../../../../apis/pool.api';
import { IProduct } from '../../../IProduct';

export function P00045FunctionReset(
  pool: Pool,
  productClass: IProduct,
  editValue: any,
) {
  editValue(
    P00039DataRxTxIndex.Connect_Installation3,
    'cnIResetUsine',
    1,
    null,
    productClass,
  );
}
